import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import { useNavigate } from "react-router-dom";
import { BaseURL } from "../../APIs/APIUrls";
import { checkUserIsLogin } from "../../APIs/APIHelperforWeb";
import { useClearLocalStorageAndRedirect } from "../../APIs/ValidateLocalStorage";

export default function MobileNav({ isLoggedIn }) {
  const navigate = useNavigate();
  const clearLocalStorageAndRedirect = useClearLocalStorageAndRedirect();
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [photo, setPhoto] = useState("");

  const getStoredValue = (key) => {
    const rawValue = localStorage.getItem(key);
    if (rawValue == null) return "";

    try {
      const parsedValue = JSON.parse(rawValue);
      return typeof parsedValue === "string" ? parsedValue : rawValue;
    } catch {
      return rawValue;
    }
  };

  const getDisplayablePhoto = (incomingPhoto) => {
    if (!incomingPhoto) return "";
    if (incomingPhoto.startsWith("data:") || incomingPhoto.startsWith("http")) {
      return incomingPhoto;
    }

    return `${BaseURL}${incomingPhoto.startsWith("/") ? incomingPhoto.slice(1) : incomingPhoto}`;
  };

  const isUserLoggedIn = typeof isLoggedIn === "boolean" ? isLoggedIn : checkUserIsLogin();

  useEffect(() => {
    if (!isUserLoggedIn) {
      setAccountDropdownOpen(false);
      setUsername("");
      setPhoto("");
      return;
    }

    setUsername(getStoredValue("username"));
    setPhoto(getDisplayablePhoto(getStoredValue("photo")));
  }, [isUserLoggedIn]);

  useEffect(() => {
    // Select all elements with the class 'dropdown2' inside '.mobile-nav'
    const dropdowns = document.querySelectorAll(".mobile-nav .dropdown2");

    // Define a function to handle the click
    const handleClick = (event) => {
      // Remove the 'open' class from all dropdowns
      const currentDropdown = event.currentTarget;
      dropdowns.forEach((item) => {
        if (currentDropdown != item) {
          item.classList.remove("open");
          const ulElement = item.querySelector("ul");
          if (ulElement) ulElement.style.height = "0px";
          if (ulElement) ulElement.style.padding = "0px 20px";
        }
      });

      // Toggle the 'open' class on the clicked dropdown

      if (!currentDropdown.classList.contains("open")) {
        // Collapse the dropdown
        currentDropdown.classList.add("open");
        const ulElement = currentDropdown.querySelector("ul");
        if (ulElement)
          ulElement.style.height = `${ulElement.scrollHeight + 30}px`;
        ulElement.style.padding = "15px 20px";
      } else {
        currentDropdown.classList.remove("open");
        const ulElement = currentDropdown.querySelector("ul");
        if (ulElement) ulElement.style.height = "0px";
        if (ulElement) ulElement.style.padding = "0px 20px";
        // Expand the dropdown
      }
    };

    // Add click event listener to each dropdown
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("click", handleClick);
    });

    // Cleanup function to remove event listeners on component unmount
    return () => {
      dropdowns.forEach((dropdown) => {
        dropdown.removeEventListener("click", handleClick);
      });
      document.body.classList.remove("mobile-menu-visible");
    };
  }, []);
  return (
    <div
      className="navbar-collapse collapse clearfix"
      id="navbarSupportedContent"
    >
      {
        isUserLoggedIn ? (
          <div className="header-account-dropdown dropdown mobile-account-dropdown" style={{ position: "relative" }}>
            <button
              type="button"
              className="box-avatar dropdown-toggle"
              onClick={() => setAccountDropdownOpen((current) => !current)}
              aria-expanded={accountDropdownOpen}
              style={{ border: "none", background: "transparent", padding: 0, display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10px", width: "100%" }}
            >
              <div className="avatar avt-34 round">
                {photo ? (
                  <img alt="profile" src={photo} width={38} height={38} />
                ) : (
                  <svg
                    width={34}
                    height={34}
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#header-avatar-clip)">
                      <path
                        d="M10.0007 9.99947C10.9357 9.99947 11.8496 9.72222 12.627 9.20278C13.4044 8.68334 14.0103 7.94504 14.3681 7.08124C14.7259 6.21745 14.8196 5.26695 14.6372 4.34995C14.4547 3.43295 14.0045 2.59063 13.3434 1.92951C12.6823 1.26839 11.84 0.81816 10.923 0.635757C10.006 0.453354 9.05546 0.54697 8.19166 0.904766C7.32787 1.26256 6.58957 1.86847 6.07013 2.64586C5.55069 3.42326 5.27344 4.33723 5.27344 5.2722C5.27469 6.52556 5.77314 7.72723 6.65941 8.6135C7.54567 9.49976 8.74734 9.99821 10.0007 9.99947ZM10.0007 2.12068C10.624 2.12068 11.2333 2.30551 11.7516 2.65181C12.2699 2.9981 12.6738 3.4903 12.9123 4.06616C13.1509 4.64203 13.2133 5.27569 13.0917 5.88702C12.9701 6.49836 12.6699 7.05991 12.2292 7.50065C11.7884 7.9414 11.2269 8.24155 10.6155 8.36315C10.0042 8.48476 9.37054 8.42235 8.79468 8.18382C8.21881 7.94528 7.72661 7.54135 7.38032 7.02308C7.03403 6.50482 6.8492 5.89551 6.8492 5.2722C6.8492 4.43636 7.18123 3.63476 7.77225 3.04374C8.36328 2.45271 9.16488 2.12068 10.0007 2.12068Z"
                        fill="white"
                      />
                      <path
                        d="M10.0011 11.5762C8.12108 11.5783 6.31869 12.326 4.98934 13.6554C3.65999 14.9847 2.91224 16.7871 2.91016 18.6671C2.91016 18.876 2.99316 19.0764 3.14092 19.2242C3.28868 19.372 3.48908 19.455 3.69803 19.455C3.90699 19.455 4.10739 19.372 4.25515 19.2242C4.4029 19.0764 4.48591 18.876 4.48591 18.6671C4.48591 17.2044 5.06697 15.8016 6.10126 14.7673C7.13555 13.733 8.53835 13.1519 10.0011 13.1519C11.4638 13.1519 12.8666 13.733 13.9009 14.7673C14.9352 15.8016 15.5162 17.2044 15.5162 18.6671C15.5162 18.876 15.5992 19.0764 15.747 19.2242C15.8947 19.372 16.0951 19.455 16.3041 19.455C16.513 19.455 16.7134 19.372 16.8612 19.2242C17.009 19.0764 17.092 18.876 17.092 18.6671C17.0899 16.7871 16.3421 14.9847 15.0128 13.6554C13.6834 12.326 11.881 11.5783 10.0011 11.5762Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="header-avatar-clip">
                        <rect width="18.9091" height="18.9091" fill="white" transform="translate(0.546875 0.544922)" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </div>
              <p className="name">
                {username || "Account"}
                {/* <span className="icon icon-arr-down" /> */}
              </p>
            </button>

            {accountDropdownOpen ? (
              <div
                className="dropdown-menu show"
                style={{
                  display: "block",
                  position: "static",
                  minWidth: "unset",
                  width: "100%",
                  marginTop: "12px",
                }}
              >
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setAccountDropdownOpen(false);
                    navigate("/dashboard");
                  }}
                >
                  Dashboard
                </button>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setAccountDropdownOpen(false);
                    clearLocalStorageAndRedirect();
                  }}
                >
                  Logout
                </button>
              </div>
            ) : null}
          </div>
        ) : null
      }

      <ul className="navigation clearfix mobile-nav">
        <Nav />
      </ul>
    </div>
  );
}
